module.exports = __webpack_public_path__ + "img/screw.35677f92.png";